var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v("请点击左侧导航按系统预置分析图表进行查看，并可自定义分析图表。")])])
}]

export { render, staticRenderFns }